import { safeStorage } from "../../../helpers/safeStorage"
import { decodeDiscountCodeParam } from "./BookingPricePreview/discountCodeMessages"

const SOURCE_KEY = "utmSource"
const AT_KEY = "utmSourceAt"
// Wie der Flyer-Rabattcode: localStorage statt sessionStorage, weil der Magic-Link-Login in einem neuen Tab landet;
// ein Klick gilt einen Tag lang als Herkunft der Buchung.
const UTM_SOURCE_TTL_MS = 24 * 60 * 60 * 1000

// Nur Buchstaben, Ziffern, Punkt, Bindestrich, Unterstrich: ein manipulierter Link darf weder die App
// (kaputtes Prozent-Encoding wirft) noch die Buchung (Backend-Feld 64 Zeichen) stören.
const VALID_SOURCE = /^[\w.-]{1,64}$/

const forgetUtmSource = () => {
    safeStorage.removeItem(SOURCE_KEY)
    safeStorage.removeItem(AT_KEY)
}

// Ein neuer Link ersetzt die alte Herkunft immer, auch wenn sein Wert unbrauchbar ist.
export const rememberUtmSource = (source: string, now = Date.now()) => {
    const decoded = decodeDiscountCodeParam(source)
    if (!VALID_SOURCE.test(decoded)) {
        forgetUtmSource()
        return
    }
    safeStorage.setItem(SOURCE_KEY, decoded)
    safeStorage.setItem(AT_KEY, String(now))
}

export const readUtmSource = (now = Date.now()): string | undefined => {
    const source = safeStorage.getItem(SOURCE_KEY)
    const at = Number(safeStorage.getItem(AT_KEY))

    if (source && at > 0 && now - at < UTM_SOURCE_TTL_MS) {
        return source
    }
    forgetUtmSource()
    return undefined
}
